import type { OccupationDirectoryRepository } from "../repositories/OccupationDirectoryRepository";
import { OccupationTitlesDto } from "../dto/OccupationTitles";
import { OccupationTypesDto } from "../dto/OccupationTypes";

import { APIResponse } from "../models/APIResponse";

export class LoadOccupationDirectory {
  constructor(private readonly repo: OccupationDirectoryRepository) {}
  getTitles(): Promise<APIResponse<OccupationTitlesDto | null>> {
    return this.repo.getTitles();
  }
  getTypes(): Promise<APIResponse<OccupationTypesDto | null>> {
    return this.repo.getTypes();
  }
}

export const getOccupationTitles = (repo: OccupationDirectoryRepository) =>
  new LoadOccupationDirectory(repo);
